import React, { useContext, useState } from "react";
import "./customForm.styles.scss"
import { useFetchDestinationOptions } from "../../api/queries/destinationQueries";
import QuillTextarea from "./QuillTextArea.component";
import { useFetchLookupsByValue } from "../../api/queries/lookupQueries";
import Select from "react-select";
import { FormContext } from "../../context/form.context";
import { useFetchAdventuresOptions } from "../../api/queries/adventureQueries";

const CustomForm = ({ fields, groupedFields = [], onSubmit }) => {
  const {formData, updateFormdata} = useContext(FormContext)
  const [optionValue, setOptionValue] = useState("");
  const destinationOptions = useFetchDestinationOptions();
  const adventureOptions = useFetchAdventuresOptions();
  const { data, isLoading } = useFetchLookupsByValue(optionValue);

  if(isLoading) return <div>is loading</div>

  const handleChange = (e) => {
    const { name, value } = e.target;
    updateFormdata({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const { name, value } = e.target;
    const file = e.target.files[0];
    if (file) {
      updateFormdata({ ...formData, [name]: value, "image": file });
    }
  };

  const handleSelectManyChange = (fieldName) => (selected) => {
    // Check if the selected value has changed
    const previousSelected = formData[fieldName] || [];
    
    // Compare arrays (assuming selected is an array of values)
    const isChanged =
      selected?.length !== previousSelected?.length ||
      selected.some((item) => !previousSelected.includes(item));

    if (isChanged) {
      const selectedValues = selected ? selected.map((option) => option.value) : [];
      updateFormdata({ ...formData, [fieldName]: selectedValues });
    }
  };

  // Handle changes to grouped fields (e.g., eventPrice)
  const handleGroupedFieldChange = (groupName, index, field, value, file) => {
    const updatedGroup = [...formData[groupName]];
    updatedGroup[index][field] = value;
    if(file) updatedGroup[index]["image"] = file;
    updateFormdata({ ...formData, [groupName]: updatedGroup });
  };

  // Add a new group item (e.g., a new group-price pair for eventPrice)
  const addGroupedFieldItem = (groupName) => {
    updateFormdata({
      ...formData,
      [groupName]: [...formData[groupName], { group: "", price: "" }],
    });
  };

  // Remove a group item
  const removeGroupedFieldItem = (groupName, index) => {
    const updatedGroup = formData[groupName].filter((_, i) => i !== index);
    updateFormdata({ ...formData, [groupName]: updatedGroup });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("submit");
    onSubmit(formData);
    updateFormdata({});
  };

  const getOptions = (label) => {
    if(optionValue !== label) setOptionValue(label);
    return data;
  }
  const selectInput = (field) => {
    return (
      <select
        id={field.name}
        name={field.name}
        value={formData[field.name] || "0"}
        onChange={handleChange}
        className="custom-form__select"
        required={field.required}
        disabled={field.disabled}
      >
        <option value="0" disabled>
            select an option
        </option>
        {Array.isArray(field.options) ? field.options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        )) : field.options === "destinations" ? destinationOptions?.data?.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        )) : getOptions(field.options)?.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="custom-form">
      {fields.map((field) => {
        const shouldShow = field.showIf ? field.showIf(formData) : true;

        if (!shouldShow) {
          return null;
        }

        return (
        <div key={field.name} className="custom-form__field">
          <label htmlFor={field.name} className="custom-form__label">
            {field.label}
          </label>
          {(() => {
            switch (field.type) {
              case "textarea":
                return (
                  <QuillTextarea
                    label={field.name}
                    name={field.name}
                    value={formData[field.name]}
                    onChange={handleChange}
                    placeholder="Write your description..."
                    required
                  />
                );
              case "select":
                return selectInput(field);
              case "selectMany":
                var options = Array.isArray(field.options)
                  ? field.options
                  : field.options === "destinations"
                  ? destinationOptions?.data
                  : field.options === "adventures" ? adventureOptions?.data?.Value : getOptions(field.options);
                  console.log(options)
                return (
                  <Select
                    options={options}
                    isMulti
                    name={field.name}
                    onChange={handleSelectManyChange(field.name)}
                    placeholder=""
                  />
                );
              case "checkbox":
                return (
                  <input
                    type="checkbox"
                    id={field.name}
                    name={field.name}
                    checked={formData[field.name]}
                    onChange={handleChange}
                    className="custom-form__checkbox"
                    required={field.required}
                  />
                );
              case "radio":
                return field.options?.map((option) => (
                  <label
                    key={option.value}
                    className="custom-form__radio-label"
                  >
                    <input
                      id={`${field.name}-${option.label}`}
                      type="radio"
                      name={field.name}
                      defaultChecked={
                        formData[field.name] === option.value ||
                        (formData[field.name] == "" && option.value == false)
                      }
                      value={option.value}
                      onChange={handleChange}
                      className="custom-form__radio"
                      required={field.required}
                    />
                    {option.label}
                  </label>
                ));
              case "number":
                return (
                  <input
                    type="number"
                    id={field.name}
                    name={field.name}
                    value={formData[field.name]}
                    min="0"
                    step="1"
                    max={field.max}
                    onChange={handleChange}
                    className="custom-form__input"
                    required={field.required}
                    placeholder={field.placeholder}
                  />
                );
              case "hidden":
                return (
                  <input
                    type="hidden"
                    id={field.name}
                    name={field.name}
                    value={formData[field.name]}
                    onChange={handleChange}
                    className="custom-form__input"
                    required={field.required}
                    placeholder={field.placeholder}
                  />
                );
              default:
                return (
                  <input
                    type={field.type || "text"}
                    id={field.name}
                    name={field.name}
                    defaultValue={formData[field.name]}
                    value={formData[field.name]}
                    onChange={
                      field.type === "file" ? handleFileChange : handleChange
                    }
                    className="custom-form__input"
                    required={field.required}
                    placeholder={field.placeholder}
                    accept={field.accept}
                  />
                );
            }
            })()
          }
        </div>
      )} 
    )}

      {groupedFields.map((group) => (
        <div key={group.name} className="custom-form__group">
          <label className="custom-form__label">{group.label}</label>
          {formData[group.name]?.map((item, index) => (
            <div key={index} className="custom-form__group-item">
              {group?.fields?.map((field) => (
                <div key={field.name} className={`custom-form__group-item__field ${field?.class ?? ""}`}>
                  <label className="custom-form__group-label" htmlFor={`${group.name}[${index}].${field.name}`}>{field.label}</label>
                  { field.type === "select" ? <select
                      id={field.name}
                      name={field.name}
                      value={item[field.name] || "0"}
                      onChange={(e) => handleGroupedFieldChange(group.name, index, field.name, e.target.value)}
                      className="custom-form__select"
                      required={field.required}
                    >
                      <option value="0" disabled>
                          select an option
                      </option>
                      {Array.isArray(field.options) ? field.options.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      )) : field.options === "destinations" ? destinationOptions?.data?.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      )) : getOptions(field.options)?.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select> : 
                    field.type === "radio" ?
                    field.options?.map((option) => (
                      <label key={option.value} className="custom-form__radio-label">
                        <input
                          id={`${field.name}-${option.label}`}
                          type="radio"
                          name={field.name}
                          value={option.value}
                          onChange={(e) => handleGroupedFieldChange(group.name, index, field.name, e.target.value)}
                          className="custom-form__radio"
                          required={field.required}
                        />
                        {option.label}
                      </label>
                    )) :
                    <input
                      type={field.type || "text"}
                      value={item[field.name]}
                      onChange={field.type === "file" ? (e) => handleGroupedFieldChange(group.name, index, field.name, e.target.value, e.target.files[0]) :
                          (e) => handleGroupedFieldChange(group.name, index, field.name, e.target.value)}
                      placeholder={field.placeholder}
                      required={field.required}
                      className="custom-form__input"
                      min="0"
                      step="1"
                      max={field.max}
                      name={field.name}
                    />
                  }
                </div>
              ))}
              <button className="custom-form__group-remove" type="button" onClick={() => removeGroupedFieldItem(group.name, index)}>
                &times;
              </button>
            </div>
          ))}
          <button className="custom-form__group-add" type="button" onClick={() => addGroupedFieldItem(group.name)}>
            Add {group.label}
          </button>
        </div>
      ))}
      <button type="submit" className="custom-form__button">
        Submit
      </button>
    </form>
  );
};

export default CustomForm;